module.exports = __webpack_public_path__ + "img/bg.fdb49316.jpg";